/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phaseclosed1Inputs */

const en_phaseclosed1 = /** @type {(inputs: Phaseclosed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const pt_phaseclosed1 = /** @type {(inputs: Phaseclosed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechado`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Phaseclosed1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const phaseclosed1 = /** @type {((inputs?: Phaseclosed1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phaseclosed1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phaseclosed1(inputs)
	return pt_phaseclosed1(inputs)
});
export { phaseclosed1 as "phaseClosed" }